import { render, staticRenderFns } from "./StokListesiFiyatLoglari.vue?vue&type=template&id=183b2ebd"
import script from "./StokListesiFiyatLoglari.vue?vue&type=script&lang=js"
export * from "./StokListesiFiyatLoglari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports